import { render, staticRenderFns } from "./AccountingBooksAccountsList.vue?vue&type=template&id=52f251b1&"
import script from "./AccountingBooksAccountsList.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksAccountsList.vue?vue&type=style&index=0&id=52f251b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports